var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRoundedRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 4.37114e-07C7.76142 1.95703e-07 10 2.23858 10 5C10 7.76142 7.76142 10 5 10C2.23858 10 1.6322e-06 7.76142 1.39079e-06 5C1.14938e-06 2.23858 2.23858 6.78525e-07 5 4.37114e-07ZM5.45035 5.06621C5.50361 5.01675 5.50361 4.93246 5.45035 4.88301L4.09493 3.62441C3.94316 3.48348 3.93437 3.24621 4.0753 3.09444C4.21623 2.94267 4.4535 2.93389 4.60527 3.07481L5.96069 4.33341C6.33349 4.67959 6.33349 5.26963 5.96069 5.6158L4.60527 6.87441C4.4535 7.01533 4.21623 7.00654 4.0753 6.85478C3.93437 6.70301 3.94316 6.46574 4.09493 6.32481L5.45035 5.06621Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRoundedRight);
export default __webpack_public_path__ + "static/media/arrow-rounded-right.a69dd4cacd1aa82bad97826b1d00be6e.svg";
export { ForwardRef as ReactComponent };